class CnUtils {
  
  static USCC_PATTERN = /[1-9ANY][123459](100000|110000|11010[1-9]|1101[1-9]\d|110[2-9]\d{2}|11[1-9]\d{3}|[2-5]\d{5}|6[0-4]\d{4}|65[0-8]\d{3}|6590\d{2}|990000)[0-9A-Z]{8}[0-9X][0-9A-HJ-NPQRTUWXY]/;
  
  static USCC_CHARS = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K',
    'L', 'M', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X', 'Y'
  ];
  
  static USCC_WEIGHTS = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];

  /**
   * Валидирует китайский USCC (Unified Social Credit Code)
   * @param {string} value - USCC для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateUSCC(value) {
    if (typeof value !== 'string') return null;
    if (value.length !== 18) return 'USCC должен быть 18 символов длиной';
    if (!CnUtils.USCC_PATTERN.test(value)) return 'Некорректный USCC';

    let checksum = 0;

    for (let i = 0; i < 17; i++) {
      const char = value[i];
      const num = CnUtils.USCC_CHARS.indexOf(char);
      const weight = CnUtils.USCC_WEIGHTS[i];
      checksum += num * weight;
    }
    checksum = 31 - (checksum % 31);

    return CnUtils.USCC_CHARS[checksum % 31] === value[17] ? null : 'Некорректный USCC';
  }
}

export default CnUtils;